import { Paper, TextField, Button, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import {DataGrid} from "@mui/x-data-grid";
import { fetchHotelsbyUSP, fetchDest, fetchHotelsbyTagsOr, fetchHotelsbyTagsAnd } from "../api/customerapi";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(60),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        align:"left",
      },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(18),
        height: theme.spacing(5),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(1),
        fontSize: 14
      },
      
  }));

const Searchhotel = () => {

    const classes = useStyles();
    const width = window.innerWidth-200;
    //console.log(width);
    const columns = [
    { field: 'hotel_id', 
      headerName: ' Hotel ID', 
      width: width/12,
      cellClassName: "gridcell"
      //align:"center",
      //headerAlign:"center"
    },
      { field: 'hotel_name', 
      headerName: ' Hotel Name', 
      width: width/12*2,
      cellClassName: "gridcell"
      //align:"center",
      //headerAlign:"center"
    },
      {
        field: 'hotel_city',
        headerName: 'City',
        width: width/12*1.5,
        
      },
      {
        field: 'hotel_price_range',
        headerName: 'Price Range',
        width: width/12*1,
      },
      {
        field: 'star_category',
        headerName: 'Star Category',
        width: width/12*1,
      },
      {
        field: 'tripadvisor_rating',
        headerName: 'TripAdvisor Rating',
        width: width/12*1,
      },
      {
        field: 'distance_from_center',
        headerName: 'Distance from Center',
        width: width/12*1,
      },
      
      {
        field: 'hotel_usp',
        headerName: 'USP',
        width: width/12*3.5,
            /*valueGetter: (params) =>
          `${params.getValue(params.id, 'firstName') || ''} ${
            params.getValue(params.id, 'lastName') || ''
          }`,*/
      },
      
    ];
    const columns2 = [
      { field: 'hotel_id', 
        headerName: ' Hotel ID', 
        width: width/12,
        cellClassName: "gridcell"
        //align:"center",
        //headerAlign:"center"
      },
        { field: 'hotel_name', 
        headerName: ' Hotel Name', 
        width: width/12*2,
        cellClassName: "gridcell"
        //align:"center",
        //headerAlign:"center"
      },
        {
          field: 'hotel_city',
          headerName: 'City',
          width: width/12*1.5,
          
        },
        {
          field: 'hotel_price_range',
          headerName: 'Price Range',
          width: width/12*1,
        },
        {
          field: 'star_category',
          headerName: 'Star Category',
          width: width/12*1,
        },
        {
          field: 'tripadvisor_rating',
          headerName: 'TripAdvisor Rating',
          width: width/12*1,
        },
        {
          field: 'distance_from_center',
          headerName: 'Distance from Center',
          width: width/12*1,
        },
        
        {
          field: 'hotel_usp',
          headerName: 'USP',
          width: width/12*3.5,
              /*valueGetter: (params) =>
            `${params.getValue(params.id, 'firstName') || ''} ${
              params.getValue(params.id, 'lastName') || ''
            }`,*/
        },
        
      ];

    const [searchData, setsearchData]=useState([{
        
    }]);
    const [dest, setdest]=useState([])
    const [searchData2, setsearchData2]=useState({
      tag_onthebeach:false,
    tag_nearbeach:false,
    tag_bathtub:false,
    tag_mountainview:false,
    tag_riverfront:false,
    tag_oceanview:false,
    tag_cottage:false,
    tag_privatepool:false,
    hotel_destination: "",
    }

    );

    const [listhotelData, setlisthotelData]=useState([{
        hotel_name: "",
        hotel_city:"",
        hotel_destination: "",
        
        hotel_tripadvisor_link: "",
        city_center_area: "",
        
        hotel_usp: "",
    }]);

    const [listhotelData2, setlisthotelData2]=useState([{
      hotel_name: "",
      hotel_city:"",
      hotel_destination: "",
      
      hotel_tripadvisor_link: "",
      city_center_area: "",
      
      hotel_usp: "",
  }]);

    useEffect(() => {
        
        getDest()
        
    }, [])

    const getDest = async () => {
      try{
      const data = await fetchDest();
      const temp=data.data.filter(d=>"order" in d)
      setdest(temp[0].dest);
    }catch(err){
      console.log(err)
    }
    };
      
          
      //console.log(searchData)
      const handleSearch = async (e) => {
        try{
          //console.log(searchData.data)
          const data = await fetchHotelsbyUSP(searchData.data, searchData.hotel_destination);
          //console.log(data);
          //const custdatalistfromdb= data.data
          setlisthotelData(data.data)
        }catch(err){
          console.log(err)
        }
      }

      const handleSearch2 = async (e) => {
        try{
        console.log(searchData2)
        const data = await fetchHotelsbyTagsOr(searchData2.tag_bathtub,searchData2.tag_onthebeach,searchData2.tag_nearbeach,searchData2.tag_mountainview,searchData2.tag_riverfront,searchData2.tag_oceanview,searchData2.tag_cottage,searchData2.tag_privatepool,searchData2.hotel_destination);
        //console.log(data);
        //const custdatalistfromdb= data.data
        setlisthotelData2(data.data)
      }catch(err){
        console.log(err)
      }
    }

    const handleSearch3 = async (e) => {
      try{
      console.log(searchData2)
      const data = await fetchHotelsbyTagsAnd(searchData2.tag_bathtub,searchData2.tag_onthebeach,searchData2.tag_nearbeach,searchData2.tag_mountainview,searchData2.tag_riverfront,searchData2.tag_oceanview,searchData2.tag_cottage,searchData2.tag_privatepool,searchData2.hotel_destination);
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlisthotelData2(data.data)
    }catch(err){
      console.log(err)
    }
  }

      const hoteldatalistdisplay=listhotelData.map(hoteldata=>({hotel_name: hoteldata.hotel_name, 
        hotel_id: hoteldata.hotel_id,
        id:listhotelData.indexOf(hoteldata), 
        hotel_city:hoteldata.hotel_city, 
        hotel_price_range:hoteldata.hotel_price_range, 
        star_category:hoteldata.star_category, 
        tripadvisor_rating:hoteldata.hotel_tripadvisor_rating,
        distance_from_center:hoteldata.distance_from_center,
        hotel_usp:hoteldata.hotel_usp  }));

        const hoteldatalistdisplay2=listhotelData2.map(hoteldata=>({hotel_name: hoteldata.hotel_name, 
          hotel_id: hoteldata.hotel_id,
          id:listhotelData2.indexOf(hoteldata), 
          hotel_city:hoteldata.hotel_city, 
          hotel_price_range:hoteldata.hotel_price_range, 
          star_category:hoteldata.star_category, 
          tripadvisor_rating:hoteldata.hotel_tripadvisor_rating,
          distance_from_center:hoteldata.distance_from_center,
          hotel_usp:hoteldata.hotel_usp  }));
        console.log(hoteldatalistdisplay2);
    
      const gridcellclick=(id)=>{
        window.location = ("/hoteldataentry/"+id);
        //console.log("/custdataentry/"+id);
      }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>        
           
        <div align="center">
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Destination</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="primary destination" required  onChange={(e)=> setsearchData({...searchData, hotel_destination: e.target.value})}>
                    {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                    
                </Select>
                </FormControl>
            <TextField variant="standard"  label="Enter USP"  className={classes.textField} onChange={(e)=> setsearchData({...searchData, data: e.target.value})}/>
            <Button onClick={handleSearch} color="secondary" variant="contained" className={classes.button}>Search</Button>
            
        </div>    
        {hoteldatalistdisplay.length >0 ?
        <div style={{ height: 1200, width: '100%' }}>
        <DataGrid rows={hoteldatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.hotel_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        
        // autoHeight
        >      
      </DataGrid>      
    </div>  :
    <div align="center"><h1>No data found</h1></div>    }
    <div align="center">
    
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_onthebeach} label="On the beach" onChange={(e)=> setsearchData2({...searchData2, tag_onthebeach: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_nearbeach} label="Near beach" onChange={(e)=> setsearchData2({...searchData2, tag_nearbeach: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_bathtub} label="Bathtub" onChange={(e)=> setsearchData2({...searchData2, tag_bathtub: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_mountainview} label="Mountain View" onChange={(e)=> setsearchData2({...searchData2, tag_mountainview: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_riverfront} label="Riverfront" onChange={(e)=> setsearchData2({...searchData2, tag_riverfront: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_oceanview} label="Ocean View" onChange={(e)=> setsearchData2({...searchData2, tag_oceanview: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_cottage} label="Cottage" onChange={(e)=> setsearchData2({...searchData2, tag_cottage: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={searchData2.tag_privatepool} label="Private Pool" onChange={(e)=> setsearchData2({...searchData2, tag_privatepool: e.target.checked})}/>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Destination</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="primary destination" required  onChange={(e)=> setsearchData2({...searchData2, hotel_destination: e.target.value})}>
                    {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                    
                </Select>
                </FormControl>
                <Button onClick={handleSearch2} color="secondary" variant="contained" className={classes.button}>Or Search</Button>
                <Button onClick={handleSearch3} color="secondary" variant="contained" className={classes.button}>And Search</Button>
                
    </div>
    {hoteldatalistdisplay2.length >0 ?
        <div style={{ height: 1200, width: '100%' }}>
        <DataGrid rows={hoteldatalistdisplay2} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.hotel_id)}
        columns={columns2}
        // pageSize={20}
        autoPageSize
        // autoHeight
        >      
      </DataGrid>      
    </div>  :
    <div align="center"><h1>No data found</h1></div>    }
    </Paper>
     );
}
 
export default Searchhotel;